import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';

import messages from './messages';
import { CSWFieldId, getOrderDetailsFieldId } from '../../../../../constants/field-ids';
import DutiesAndTaxes from '../../../../../fulfillment-planner/duties-and-taxes';
import DutiesAndTaxesBanner from '../../../../../fulfillment-planner/duties-and-taxes/banner';
import { shouldShowPrepayDutyAlert } from '../../../../../fulfillment-planner/duties-and-taxes/helpers';
import { useFulfillmentPlannerContext } from '../../../../../fulfillment-planner/context';
import LabeledField from '../labeled-field';

import style from './style.module.less';

const fieldId = getOrderDetailsFieldId(CSWFieldId.DutiesAndTaxes);

const DutiesAndTaxesField = () => {
  const shouldShowPrepayDutyAlertBanner = useSelector((state) => shouldShowPrepayDutyAlert(state));
  const { shouldShowDutiesAndTaxes } = useFulfillmentPlannerContext();

  return (
    shouldShowDutiesAndTaxes && (
      <>
        <LabeledField label={<FormattedMessage {...messages.dutiesAndTaxesLabel} />} labelFor={fieldId}>
          <DutiesAndTaxes dropdownMenuType={DropdownMenuType.ComboBox} id={fieldId} />
        </LabeledField>
        {shouldShowPrepayDutyAlertBanner && (
          <div className={style.banner}>
            <DutiesAndTaxesBanner className={style['banner-message']} />
          </div>
        )}
      </>
    )
  );
};

export { DutiesAndTaxesField };
